import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BlankLayout } from '@/layout';
import { init } from '@/model/dictionary/actions';
import { makeSelectInitialized } from '@/model/dictionary/selectors';

const selectInitialized = makeSelectInitialized();

const withDictionaryInitialization = <T extends PropsWithChildren<unknown>>(Component: React.FC<T>) => (
  props: T,
): React.ReactElement<T> => {
  const dispatch = useDispatch();
  const initializing = useRef<boolean>(false);
  const initialized = useSelector(selectInitialized);
  useEffect(() => {
    if (!initialized && !initializing.current) {
      initializing.current = true;
      (async (): Promise<void> => {
        try {
          await init()(dispatch);
        } finally {
          initializing.current = false;
        }
      })();
    }
  }, [dispatch, initialized, initializing]);
  if (!initialized) {
    return <BlankLayout />;
  }

  return <Component {...props} />;
};

export default withDictionaryInitialization;
